import classnames from 'classnames';
import { SfaMatchStatusPillProps } from './sfaMatchStatusPill.types';
import styles from './sfaMatchStatusPill.module.scss';

const SfaMatchStatusPill = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-match-status-pill',
  label,
  variant = 'fullTime',
  icon,
}: SfaMatchStatusPillProps) => {
  const variantClass =
    styles[`sfaMatchStatusPill--${variant}`] ??
    styles['sfaMatchStatusPill--fullTime'];

  return (
    <span
      {...nativeProps}
      data-testid={testId}
      className={classnames(
        styles.sfaMatchStatusPill,
        variantClass,
        classNames
      )}
    >
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      {label}
    </span>
  );
};

export default SfaMatchStatusPill;
